let _ph = null;
let _sentry = null;

export const getph = () => _ph;
export const getSentry = () => _sentry;

export function initVendors() {
  const ric = window.requestIdleCallback ?? ((fn, o) => setTimeout(fn, o?.timeout ?? 1));
  ric(() => {
    import('posthog-js').then(({ default: ph }) => {
      ph.init('phc_D66syvhvSNoV2yvPBEqbidR4GyF3w9Yb3JyvU2H95Fn5', {
        api_host:        'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture:     true,
      });
      _ph = ph;
    });
    import('@sentry/react').then((s) => {
      s.init({
        dsn:                     'https://19e16361550fad5e47f953a53056d10d@o4511294415634432.ingest.us.sentry.io/4511294418255872',
        environment:             process.env.NODE_ENV,
        tracesSampleRate:        0.2,
        replaysOnErrorSampleRate: 1.0,
        sendDefaultPii:          false,
      });
      _sentry = s;
    });
  }, { timeout: 2000 });
}
